import React from 'react';
import { LoadingContainer, LoadingSpinner } from './styles'

interface LoadingProps {
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ fullScreen }) => {
  return (
    <LoadingContainer fullScreen={fullScreen}>
      <LoadingSpinner />
    </LoadingContainer>
  );
};

export default Loading; 